import { types, actions } from "./rastreamento.actions";
import { types as authTypes } from "./autenticacao.actions";

const initialState = {
  dominios: {
    empresas: {
      loading: true,
      data: [],
    },
    roteiros: {
      loading: true,
      data: [],
    },
  },
  filtros: {
    empresa: null,
    roteiros: [],
    inicioPeriodo: null,
    fimPeriodo: null,
  },
  drawer: {
    filters: false,
    showMore: false,
  },
  loading: false,
  updating: false,
  items: [],
  empresa: null,
  roteiro: null,
  opcoes: {
    percurso: true,
    atual: true,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case authTypes.LOGOUT:
      return {
        ...initialState,
      };
    case types.ALTERNAR_MAIS_CARDS:
      return {
        ...state,
        drawer: {
          ...state.drawer,
          showMore: !state.drawer.showMore,
        },
      };
    case types.EXIBIR_FILTROS:
      return {
        ...state,
        drawer: {
          ...state.drawer,
          filters: action.payload.visible,
        },
      };
    case types.ATUALIZAR_FILTROS:
      return {
        ...state,
        filtros: {
          ...state.filtros,
          ...action.payload.filtros,
        },
      };
    case types.SELECIONAR_DISPOSITIVO:
      return {
        ...state,
        roteiro: action.payload.item,
      };
    case actions.pesquisar.REQUEST:
      return {
        ...state,
        loading: true,
        items: [],
      };
    case actions.pesquisar.SUCCESS:
    case actions.pesquisar.FAILURE:
      return {
        ...state,
        loading: action.type === actions.pesquisar.REQUEST,
        items:
          action.type === actions.pesquisar.SUCCESS
            ? action.payload.response.data.items
            : state.items,
        empresa:
          action.type === actions.pesquisar.SUCCESS
            ? action.payload.response.data.empresa
            : state.empresa,
      };
    case actions.carregarEmpresas.REQUEST:
    case actions.carregarEmpresas.SUCCESS:
    case actions.carregarEmpresas.FAILURE:
      return {
        ...state,
        dominios: {
          ...state.dominios,
          empresas: {
            ...state.dominios.empresas,
            loading: action.type === actions.carregarEmpresas.REQUEST,
            data:
              action.type === actions.carregarEmpresas.SUCCESS
                ? [...action.payload.response.data]
                : state.dominios.empresas.data,
          },
        },
      };
    case actions.carregarRoteiros.REQUEST:
    case actions.carregarRoteiros.SUCCESS:
    case actions.carregarRoteiros.FAILURE:
      return {
        ...state,
        dominios: {
          ...state.dominios,
          roteiros: {
            ...state.dominios.roteiros,
            loading: action.type === actions.carregarRoteiros.REQUEST,
            data:
              action.type === actions.carregarRoteiros.SUCCESS
                ? [...action.payload.response.data]
                : state.dominios.roteiros.data,
          },
        },
      };
    case types.ALTERNAR_BOTAO:
      return {
        ...state,
        botao: state.botao === "voltar" ? "ir" : "voltar",
      };
    case types.CLEAN_RASTREAMENTO_DATA:
      return {
        ...state,
        items: [],
      };
    case types.LIMPAR_ROTEIROS:
      return {
        ...state,
        roteiro: [],
      };
    default:
      return state;
  }
};

export default reducer;
